import { useMutation } from "@tanstack/react-query"
import { createSection } from "../../../api/projects/createSection"

export const useCreateSection = () => {

  return useMutation({
    mutationKey: ["createSection"],
    mutationFn: createSection
  })
}